import store from '@/store'
import { roles } from '@/roles'

function getPathRoles(rolesArray, rolesObject) {
  for (let i = 0; i < rolesArray.length; i++) {
    const role = rolesArray[i];

    if (rolesObject.hasOwnProperty(role)) {
      return rolesObject[role].path;
    }
  }

  return null;
}

export const roleCheckAndRedirect = () => {
  Promise.resolve(localStorage.getItem('user_type'))
    .then(async (userRolesString) => {
      if (!userRolesString) window.location.href = '/login'

      let redirectPath = null
      const userRolesArray = userRolesString.split(',')

      redirectPath = getPathRoles(userRolesArray, roles)

      if (redirectPath) {
        window.location.href = redirectPath
      } else {
        window.location.href = '/login'
      }
    })
    .finally(() => {
      store.commit('setIsLoading', false)
    })

  return false
}
